<script setup lang="ts">
import { useDialogStore } from "~/projects/cc/stores/dialogStore";

const dialogStore = useDialogStore();
type ShortcutList = {
  key: string;
  action: string;
};
const gridData: ShortcutList[] = [
  {
    key: "Alt + I",
    action: "Open Dialer",
  },
  {
    key: "Esc",
    action: "Close Dialer",
  },
  {
    key: "Alt + C",
    action: "Call a number on dialer",
  },
  {
    key: "Alt + A",
    action: "Accept Incoming Call",
  },
  {
    key: "Alt + R",
    action: "Resolve Ticket",
  },
  {
    key: "Alt + G",
    action: "Show Gallery Modal",
  },
  {
    key: "Alt + H",
    action: "Hold Ongoing Call",
  },
  {
    key: "Alt + H",
    action: "Show History Modal when in Inbox Page",
  },
  {
    key: "Alt + T",
    action: "Add Task related to Ongoing Call",
  },
  {
    key: "Alt + T",
    action: "Show Reply Templates Dialog when in Inbox Page",
  },
  {
    key: "Alt + N",
    action: "Add Note related to Ongoing Call",
  },
  {
    key: "Alt + W",
    action: "Show Shortcut List",
  },
  {
    key: "Alt + U",
    action: "Show Upload Dialog when in Inbox Page",
  },
];
</script>

<template>
  <el-dialog
    v-model="dialogStore._showShortcutList"
    top="0"
    title="Shortcut List"
  >
    <el-table :data="gridData">
      <el-table-column property="key" label="Key" width="200" />
      <el-table-column property="action" label="Action" width="800" />
    </el-table>
  </el-dialog>
</template>

<style scoped></style>
